export const getAvailableFilters = (reviews) => {
	const departments = [];
	const states = [];
	const makes = [];
	reviews.forEach(({ review }) => {
		const department = review?.department?._text;
		const state = review?.author?._attributes?.state;
		const make = review?.vehicle?._attributes?.make;

		if (department && !departments.includes(department)) {
			departments.push(department);
		}
		if (state && !states.includes(state)) {
			states.push(state);
		}
		if (make && !makes.includes(make)) {
			makes.push(make);
		}
	});
	return [
		{ type: 'department', values: departments },
		{ type: 'state', values: states },
		{ type: 'make', values: makes }
	];
};
